import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  const currentYear = new Date().getFullYear();
  const copyrightYear = currentYear > 2026 ? `2026 - ${currentYear}` : currentYear;

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-links">
          <Link to="/privacy" className="footer-link">Privacy Policy</Link>
          <span className="footer-separator">|</span>
          <Link to="/terms" className="footer-link">Terms of Service</Link>
        </div>
        <p className="footer-text">
          © {copyrightYear} Lilley Tech Syndicate LLC. All rights reserved.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
